var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Bullet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#AD80CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7051 34C24.4491 34 24.3211 33.872 24.3211 33.616V20.608H21.4651C21.3531 20.608 21.2571 20.576 21.1771 20.512C21.0971 20.432 21.0571 20.336 21.0571 20.224V17.584C21.0571 17.472 21.0971 17.384 21.1771 17.32C21.2571 17.24 21.3531 17.2 21.4651 17.2H27.9691C28.2251 17.2 28.3531 17.328 28.3531 17.584V33.616C28.3531 33.872 28.2251 34 27.9691 34H24.7051Z",
    fill: "#FECC3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Bullet);
export default __webpack_public_path__ + "static/media/1-bullet.b6b86bbe11886625094ba26ad3d432e5.svg";
export { ForwardRef as ReactComponent };